export default __webpack_public_path__ + "static/media/glasses-blue-green.391f6e3c.svg";